import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemImportJsonRoute: InvariantJiraRoute = {
	name: 'global-settings-system-import-json',
	path: '/secure/admin/Json(\\w+)Page([!%]?[\\w]*).jspa',
};
